<template>
    <div class="table">
        <div class="commonSearch" ref="commonSearchRef">
            <el-form class="el-form el-form--inline" onsubmit="return false">
                <el-form-item>
                    <el-button type="primary" plain icon="el-icon-edit" @click="openEditDlg('','')">新增</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="danger" plain icon="el-icon-delete" @click="deleteData">删除</el-button>
                </el-form-item>
                <el-form-item class="head-right">
                    <el-button type="info" plain icon="el-icon-search" @click="initDataBySearch">查询</el-button>
                </el-form-item>
                <el-form-item class="head-right">
                    <el-input v-model.trim="select_word" placeholder="请输入角色编号/角色名称" clearable style="width:220px"></el-input>
                </el-form-item>
                <el-form-item class="head-right">
                    <el-select v-model="platformType" placeholder="请选择操作平台" @change="changePlatform">
                        <el-option v-for="item in operateType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属系统" class="head-right">
                    <el-select v-model="systemType" placeholder="请选择系统" clearable @change="changePlatform">
                        <el-option v-for="item in systemTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div style="clear:both"></div>
        </div>

        <div class="commonTable">
            <el-table :data="returnData" style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange" @select="handleSelect" @select-all="handleSelection" v-loading="loading" element-loading-text="拼命加载中" size="medium" :height="tabHeight">
                <el-table-column type="selection" width="55" @selection-change="handleSelectionChange"></el-table-column>
                <el-table-column prop="code" label="角色编号" align="left" min-width="150"> </el-table-column>
                <el-table-column prop="name" label="角色名称" align="left" min-width="150"></el-table-column>
                <el-table-column prop="remark" label="角色描述" align="left" min-width="150"></el-table-column>
                <el-table-column prop="roleRange" label="角色数据范围" align="left" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.roleRange==20">所属公司/部门</span>
                        <span v-if="scope.row.roleRange==21">所在公司/部门</span>
                        <span v-if="scope.row.roleRange==40">个人级</span>
                    </template>
                </el-table-column>
                <el-table-column prop="roleAdmin" label="角色管理员" width="100" align="left">
                    <template slot-scope="scope">
                        <span v-if="scope.row.roleAdmin==true">是</span>
                        <span v-if="scope.row.roleAdmin==false">否</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="110" align="left">
                    <template slot-scope="scope">
                        <span style="cursor:pointer" type="primary" class="fa fa-edit fa-2x btnColor" @click="openEditDlg(scope.$index,scope.row)" title="编辑"></span>
                        <span style="margin-left:10px;cursor:pointer" class="fa fa-user fa-2x btnColor" @click="openMenuDialog(scope.$index,scope.row)" title="授权"></span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页框 -->
        <div class="commonPage">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="cur_page" :page-sizes="[5, 10, 15, 30]" layout="total, sizes, prev, pager, next, jumper" :total="totalCount" :disabled="loading"></el-pagination>
        </div>

        <div>
            <EditDlg v-if="editDlgShow" ref="editDlgRef"></EditDlg>
            <DetailsDlg v-if="detailsDlgShow" ref="detailsDlgRef"></DetailsDlg>
            <MenuDlg v-if="menuDlgShow" @node-data="handleCallDataByDlg" ref="menuDlgRef"></MenuDlg>
            <OrganizationDlg v-if="organizationDlgShow" @node-data="handleCallData" ref="organizationDlgRef"></OrganizationDlg>
        </div>
    </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import EditDlg from "./RoleManageEditDlg.vue";
import MenuDlg from "../menuManage/MenuManageDlg.vue";
import OrganizationDlg from "../organizationManage/OrganizationDlg.vue";
import SettingApi from "@/api/setting.js";

export default {
    mixins: [TabResize],
    components: {
        EditDlg,
        MenuDlg,
        OrganizationDlg
    },
    mounted: function () {
        //初始化
        this.per_page = this.$constant.PAGE_SIZE;
        this.platformType = "1";
        this.loadSystems();
        this.initData();
    },
    data () {
        return {
            operateType: [
                {
                    value: "1",
                    label: "Web"
                },
                {
                    value: "2",
                    label: "App"
                }
            ],
            systemType: this.$constant.CATALOG,
            systemTypes: [],
            platformType: "",
            menuDlgShow: false,
            detailsDlgShow: false,
            editDlgShow: false,
            loading: true,
            returnData: [],
            cur_page: 1,
            cacheData: {},
            multipleSelection: [],
            select_word: "",
            organizationDlgShow: false,
            totalCount: 0,
            per_page: "",
            rules: {
                call_type: [
                    { required: true, message: "请选择呼叫类型", trigger: "blur" }
                ]
            }
        };
    },
    watch: {},
    methods: {
        initData () {
            let param = {
                pageNum: this.cur_page,
                pageSize: this.per_page,
                keyword: this.select_word,
                type: this.platformType,
                systemId: this.systemType
            };
            //获取组织架构数据
            // this.$mhttp.httpGet(
            //   this.$constant.API_NSC + "uc/role/roles/page",
            //   param,
            //   null
            // );

            SettingApi.getClass()
                .getRoleListData(param)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        this.totalCount = res2.data.data.totalElements;
                        this.returnData = res2.data.data.data;
                        this.initSelect();
                        this.loading = false;
                    } else {
                        this.$message.error(res2.data.msg);
                        this.loading = false;
                        return false;
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },
        //获取选中行
        handleSelectionChange (val) {
            this.multipleSelection = val;
        },
        handleSelect (selection, row) {
            this.cacheData[this.cur_page] = selection;
        },
        handleSelection (selection) {
            this.cacheData[this.cur_page] = selection;
        },
        initSelect () {
            for (let prop in this.cacheData) {
                if (prop == this.cur_page) {
                    if (this.cacheData[prop] && this.cacheData[prop].length > 0) {
                        this.$nextTick(() => {
                            this.checkIsSelected(this.cacheData[prop]);
                        });
                    }
                }
            }
        },
        checkIsSelected (selectedData) {
            this.returnData.forEach(element => {
                selectedData.forEach(el => {
                    if (el.id == element.id) {
                        this.$refs.multipleTable.toggleRowSelection(element, true);
                    }
                });
            });
        },
        // 分页导航
        handleCurrentChange (val) {
            this.cur_page = val;
        },
        //切换每页显示多条
        handleSizeChange (val) {
            this.per_page = val;
            this.cur_page = 1;
            this.loading = true;
            this.initData();
        },
        // 切换显示第几页
        handleCurrentChange (val) {
            this.cur_page = val;
            this.loading = true;
            this.initData();
        },
        initDataBySearch () {
            this.cur_page = 1;
            this.initData();
        },
        getSelectedTime () { },
        openEditDlg (index, row) {
            this.editDlgShow = true;
            let operateFlag = "";
            if (row != null && row != "") {
                operateFlag = "update";
                this.$nextTick(() => {
                    this.$refs.editDlgRef.init(
                        row,
                        operateFlag,
                        this.platformType,
                        this.systemType
                    );
                });
            } else {
                operateFlag = "add";
                this.$nextTick(() => {
                    this.$refs.editDlgRef.init(
                        "",
                        operateFlag,
                        this.platformType,
                        this.systemType
                    );
                });
            }
        },

        //删除用户
        deleteData () {
            let idList = new Array();
            if (this.multipleSelection.length == 0) {
                this.$message.error("请至少选择一条要删除的数据！");
                return false;
            }
            //遍历选中的checkbox数据集合 拿出其中的ids
            for (let i = 0; i < this.multipleSelection.length; i++) {
                idList[i] = "" + this.multipleSelection[i]["id"];
            }
            let param = {
                ids: idList
            };
            this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    // this.$mhttp.httpPost(
                    //   this.$constant.API_NSC + "uc/role/del/multiple",
                    //   param,
                    //   "application/json"
                    // );
                    this.loading = true;
                    SettingApi.getClass()
                        .deleteRoleById(param)
                        .then(res2 => {
                            if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                                this.$message.success("删除成功！");
                                this.loading = false;
                                this.refreshData();
                            } else {
                                this.$message.error(res2.data.msg);
                                this.loading = false;
                                return false;
                            }
                        })
                        .catch(err => {
                            this.$message.error(err);
                            this.loading = false;
                            return false;
                        });
                })
                .catch(() => { });
        },
        openElTreeDialog () {
            this.organizationDlgShow = true;
            this.$nextTick(() => {
                // type 必传 0表示全部的组织架构 每个都可以选 1 表示分部  2部门
                // id  可选  传入id可以默认选中当前传入的id节点 如果不需要默认选中 就传null
                this.$refs.organizationDlgRef.init(2, null, null);
            });
        },
        handleCallData (nodeData) { },
        openMenuDialog (index, row) {
            this.menuDlgShow = true;
            this.$nextTick(() => {
                // type 必传 0表示全部的组织架构 每个都可以选 1 表示分部  2部门
                // id  可选  传入id可以默认选中当前传入的id节点 如果不需要默认选中 就传null
                this.$refs.menuDlgRef.init(
                    2,
                    this.showParentId,
                    null,
                    row,
                    this.platformType,
                    this.systemType
                );
            });
        },
        handleCallDataByDlg (nodeData) {
            let idList = [];
            for (let i = 0; i < nodeData.length; i++) {
                idList.push(nodeData[i].id);
            }
        },
        changePlatform () {
            // alert(this.platformType);
            this.initData();
        },
        loadSystems () {
            SettingApi.getClass()
                .loadSystems()
                .then(res => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res.data.code) {
                        this.systemTypes = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        refreshData () {
            let length = this.multipleSelection.length;
            if (length == null || length == "") {
                length = 1;
            }
            let m = Math.ceil((this.totalCount - length) / this.per_page);
            if (this.cur_page > 1 && this.cur_page > m) {
                this.cur_page = this.cur_page - 1;
            }
            this.initData();
        }
    }
};
</script>

<style lang="stylus" scoped>
.head-right {
    float: right;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}

.btnColor {
    color: $theme-color;
}
</style>
